// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import UUID from 'vue-uuid';
import EdocUi from 'edoc-ui';
import OtpInput from '@bachdgvn/vue-otp-input';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import App from './App';
import i18n from './i18n';
import store from './store';
import router from './router';

// Make sure this is before any other `fontawesome` API calls
config.autoAddCss = false;

library.add(faCheck, faTimes);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('v-otp-input', OtpInput);

Vue.use(UUID);
Vue.use(EdocUi);

require('edoc-ui/lib/edoc-ui.css');
require('@/assets/scss/main.scss');
require('../node_modules/@fortawesome/fontawesome-svg-core/styles.css');

store.dispatch('conf/load');


Vue.config.productionTip = false;

// widget for support
window.AGO = {
  title: 'Assistant eDocPerso',
  icon: '/static/img/support-widget.png',
  basepath: 'https://silae.useago.com/',
  prompt: i18n.t('widget.support.prompt'),
  widgetApiKey: 'silae_public_key_AHUIUY678H',
  colors: {
    button: '#2b627b',
    header: '#2b627b',
  },
};

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App),
});

export default { app, router, store, i18n };



// WEBPACK FOOTER //
// ./src/main.js